import React from 'react';
import PropTypes from 'prop-types';
import { Route, Redirect } from 'react-router-dom';

const ProtectedRoute = ({
  component: Comp,
  loggedIn,
  path,
  computedMatch,
  redirectPath,
  ...rest
}) => (
  <Route
    path={path}
    {...rest}
    render={(props) => (loggedIn ? (
      <Comp {...props} />
    ) : (
      <Redirect
        to={{
          pathname: redirectPath,
          state: {
            prevLocation: computedMatch.url,
            error: 'You need to login first!',
          },
        }}
      />
    ))}
  />
);

ProtectedRoute.defaultProps = {};
ProtectedRoute.propTypes = {
  component: PropTypes.shape().isRequired,
  computedMatch: PropTypes.shape().isRequired,
  loggedIn: PropTypes.bool.isRequired,
  path: PropTypes.string.isRequired,
  redirectPath: PropTypes.string.isRequired,
};

export default ProtectedRoute;
